// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".custom-radio-eticket-template{margin-right:1rem}.custom-radio-eticket-template .custom-control-label{margin-top:1px}", ""]);
// Exports
module.exports = exports;
